import React from 'react';

const PenIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      role="presentation"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9356 2.19979L11.0823 0.346479C10.9102 0.174355 10.5658 0.238785 10.3145 0.489982L9.34741 1.45708L9.44965 1.55931L9.73762 1.84727L11.8081 3.91772L11.825 3.9347L12.7921 2.9676C13.0434 2.71636 13.1078 2.37191 12.9356 2.19979Z"
        fill="#5A3218"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.16809 2.41657L8.77788 2.02637L1.9729 8.83134L2.36311 9.22155L4.06038 10.9188L4.45054 11.309L11.2555 4.50399L10.8654 4.11384L9.16809 2.41657Z"
        fill="#5A3218"
      />
      <mask
        id="mask0_227_15730"
        maskUnits="userSpaceOnUse"
        x="0"
        y="9"
        width="4"
        height="5"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 9.40137H3.88103V13.2823H0V9.40137Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_227_15730)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.39466 11.3926L1.88977 9.88768L1.65936 9.65728L1.40347 9.40137L0.0282482 12.894C-0.0206508 13.0182 -0.00536303 13.1398 0.0686593 13.2137C0.124771 13.27 0.208483 13.2923 0.30004 13.2783C0.328867 13.2739 0.358568 13.2659 0.388391 13.2542L3.88103 11.8789L3.68596 11.6839L3.39466 11.3926Z"
          fill="#5A3218"
        />
      </g>
    </svg>
  );
};

export default PenIcon;
